import React from "react";
import { animation } from "polished";
import IconButton from "@material-ui/core/IconButton";
import InputAdornment from "@material-ui/core/InputAdornment";
import SearchIcon from "@material-ui/icons/Search";
import LoadingIcon from "@material-ui/icons/Autorenew";

import { ThemeType } from "@theme";
import locale from "@bonliva-crm/locale";
import { makeStyles } from "@material-ui/core/styles";

export type InputLookupAdornmentProps = {
  disabled?: boolean;
  icon?: React.ReactNode;
  loading?: boolean;
  onLookup: (e: React.SyntheticEvent<any>) => any;
};

export function InputLookupAdornment(props: InputLookupAdornmentProps) {
  const classes = useStyles({});
  return (
    <InputAdornment position="end">
      <IconButton
        className={classes.lookupButton}
        color="secondary"
        disabled={props.disabled}
        title={locale.LookUp}
        onClick={props.onLookup}
      >
        {props.loading ? <LoadingIcon className={classes.loader} /> : props.icon}
      </IconButton>
    </InputAdornment>
  );
}

InputLookupAdornment.defaultProps = {
  icon: <SearchIcon />
};

const useStyles = makeStyles((theme: ThemeType) => ({
  lookupButton: {
    height: 36,
    padding: 0,
    width: 36,
    whiteSpace: "nowrap"
  },

  loader: {
    ...(animation(["spin", "1s", "infinite", "linear"]) as any)
  }
}));
